export const LOG_SOURCE = 'MsteamsAddin';

export const formatMessage = (message: string, tag?: string): string =>
    tag ? `${LOG_SOURCE} - [${tag}] ${message}` : `${LOG_SOURCE} - ${message}`;

export type LogMethod = 'info' | 'debug' | 'warn' | 'error';
